import { FC } from 'react';
import { useTheme } from '@material-ui/core';
import { WbCard, WbCardProps } from '../WbCard';

export const WbWidget: FC<WbCardProps> = ({
  children,
  cardStyle,
  headerStyle,
  footerStyle,
  ...props
}) => {
  const theme = useTheme();

  return (
    <WbCard
      headerStyle={{
        background: theme.palette.grey[100],
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        ...headerStyle,
      }}
      cardStyle={{
        boxShadow: 'none',
        border: `1px solid ${theme.palette.divider}`,
        ...cardStyle,
      }}
      footerStyle={{
        background: theme.palette.grey[100],
        ...footerStyle,
      }}
      {...props}
    >
      {children}
    </WbCard>
  );
};
